import React, { useState } from 'react'
import OEMtable from './OEMtable'
import OEMAddEdit from './AddEditOEM/Main'

export default function Main() {
    const [tab, setTab] = useState("list")
    const [data, setData] = useState({})

    const handleTab = (type, data) => {
        setData(data)
        setTimeout(() => {
            setTab(type)
        }, 200)
    }
    return (
        <>
            {
                tab === "list" ?
                    <OEMtable handleTab={handleTab}/>
                    : ''}
            {
                tab === "addEdit" ?
                    <OEMAddEdit handleTab={handleTab} Editdata={data}/>
                    : ''}

        </>
    )
}
